(function () {
    'use strict';

    angular
        .module('sod.helper')
        .directive('sodIframePreview', sodIframePreview);

    function sodIframePreview($timeout) {
        function link(scope, element) {
            var iframe = document.createElement('iframe');
            iframe.style.width = '100%';
            iframe.style.height = '100%';
            iframe.style.border = 'none';
            iframe.style.overflow = 'visible';
            iframe.height = '100%';

            var element0 = element[0];
            element0.appendChild(iframe);
            var body = iframe.contentDocument.body;
            scope.iframeHeight = iframe.contentWindow.innerHeight;

            scope.getIframeHeight = function() {
                return iframe.contentWindow.document.body.offsetHeight;
            };

            scope.resize = function() {
                iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
            };

            scope.$watch('content', function () {
                iframe.contentWindow.document.open();
                iframe.contentWindow.document.close();
                iframe.contentWindow.document.body.innerHTML = scope.content;
                setStyle();
            });

            scope.$watch(scope.getIframeHeight(), function() {
                scope.resize();
            });

            $timeout(function () {
                setStyle();
            }, 1000);

            function setStyle() {
                var css = document.createElement('style');
                css.type = 'text/css';

                var styles = [
                    '* {',
                    'font-family: Roboto, Helvetica, Arial, sans-serif;',
                    'overflow-wrap: break-word;',
                    '}',
                ].join('');

                css.appendChild(document.createTextNode(styles));

                iframe.contentWindow.document.head.appendChild(css);
            }
        }

        return {
            link: link,
            restrict: 'E',
            scope: {
                content: '=',
                resize: '=?'
            }
        };
    }
})();